import { defineStore } from 'pinia'

export const useTariffCodeStore = defineStore('tariffCode', {
  
  state: () => ({
    // Lists for different data types
    tariffCodesList: [] as any[],
    tariffCode: undefined,
    member: undefined,
    membersList: [] as any[],
    applicableYear: new Date().getFullYear().toString(),    
  }),
  
  actions: {
    // ============================================
    // Tariff Code Actions
    // ============================================
    
    setApplicableYear(year: string) {
      this.applicableYear = year
    },
    // Replace entire list
    setTariffCodesList(response: any[]) {
      this.tariffCodesList = response
    },

    // Append multiple sunset items
    addTariffCodeToTariffCodeList(tariffCode: any) {
      // Check for duplicates (assuming there's a unique identifier)
      const exists = this.tariffCodesList.some(
        tc => tc.code === tariffCode.code
      )
      
      if (!exists) {
        this.tariffCodesList.push(tariffCode);
      } else {
        console.warn('Tariff Code already exists:', tariffCode);
      }
    },

    // Append multiple items to list
    addTariffCodes(tariffCodes: any[]) {
      this.tariffCodesList.push(...tariffCodes)
    },

    // Remove sunset item by ID
    removeTariffCodeFromTariffCodesList(code: string) {
      this.tariffCodesList = this.tariffCodesList.filter(
        tc => tc.code !== code
      )
    },

    // Clear sunset list
    clearTariffCodesList() {
      this.tariffCodesList = []
    },

    // ============================================
    // Tariff Members Actions
    // ============================================

    // Append multiple sunset items
    addMemberToMembersList(member: any) {      
      // Check for duplicates (assuming there's a unique identifier)
      const exists = this.membersList.some(
        m => m.membership_number === member.membership_number
      )
      
      if (!exists) {
        this.membersList.push(member);
      } else {
        console.warn('Member Already already exists:', member);
      }
    },

    // Remove sunset item by ID
    removeMemberFromMembersList(membershipNumber: string) {
      this.membersList = this.membersList.filter(
        m => m.membership_number !== membershipNumber
      )
    },
    // Clear all lists
    clearAllLists() {
      this.tariffCodesList = []
      this.membersList = []
    }
  },
  
  getters: {
    getApplicableYear: (state) => state.applicableYear,
    membersCount: (state) => state.membersList.length,
    tariffCodesCount: (state) => state.tariffCodesList.length,

  }
})